import type {Store} from "~/generated/types";
import {useLogger} from "~/utils/logger";

export const useAppStore = defineStore('AppStore', () => {
  const storesStore = useStoresStore()
  const logger = useLogger('AppStore')

  const isLoading = ref(false)
  const error = ref<Error | null>(null)

  type AuthState = 'authenticated' | 'unauthenticated'

  const authState = ref<AuthState>('unauthenticated')

  const shop = ref<Store | null>(null)
  const slug = ref<string | null>(null)

  const currentSlug = computed(() => slug.value)
  const currentStore = computed(() => shop.value)

  const setCurrentStore = (newSlug: string, value: Store | null): void => {
    logger.debug('setCurrentStore', newSlug, value)
    slug.value = newSlug
    shop.value = value
  }

  // 스토어 데이터 로드 함수
  const loadStore = async (slug: string) => {
    if (storesStore.getStore(slug)) return

    isLoading.value = true
    error.value = null

    try {
      const store = await useStoreValidation(slug)
      storesStore.setStore(store)
    } catch (e) {
      error.value = e as Error
    } finally {
      isLoading.value = false
    }
  }
  const previewProducts = computed(() => [])

  return {
    currentStore,
    previewProducts,
    authState,
    currentSlug,
    isLoading,
    error,
    shop,
    loadStore,
    setCurrentStore,
  }
})
